import { authAxios } from "./axiosClient";
import {
  listBangPhepNSURL,
  dieuChinhPhepCaNhanURL,
  duyetPhepTeamURL,
  listBangPhepQLURL,
  resultLeaveDaysURL,
} from "../constants";

export const ListBangPhepNSApi = (params = {}) => {
  const url = listBangPhepNSURL;
  return authAxios().get(url, { params });
};

export const dieuChinhPhepCaNhanApi = (params = {}) => {
  const url = dieuChinhPhepCaNhanURL;
  return authAxios().put(url, params);
};

export const duyetPhepTeamApi = (params = {}) => {
  const url = duyetPhepTeamURL;
  return authAxios().put(url, params);
};

export const ListBangPhepQLApi = (params = {}) => {
  const url = listBangPhepQLURL;
  return authAxios().get(url, { params });
};

export const KhaiBaoPhepApi = (params = {}) => {
  const url = listBangPhepNSURL;
  return authAxios().post(url, params);
};

export const ResultLeaveDaysApi = (params = {}) => {
  const url = resultLeaveDaysURL;
  return authAxios().post(url, params, { responseType: "blob" });
};

// export const EditPhepNamApi = (params={})=>{
//         const url = listBangPhepNSURL;
//         return authAxios().put(url,params);
// }
